import React, { useState } from "react";
import QuoteTableExpandedTable from "./QuoteTableExpandedTable";
import QuoteTableExpandedMobile from "./QuoteTableExpandedMobile";
import { getScheduleDisclaimer } from "../../utilities/scheduleDisclaimer";

const QuoteTableExpanded = ({
    departureTime,
    arrivalTime,
    departureAirport,
    arrivalAirport,
    duration,
    fuelStop,
    passengers,
    luggage,
    legData,
    ownerApproval,
}) => {
    const legsArray = Array.isArray(legData) ? legData : [];
    const totalLegs = legsArray.length;
    const hasManyLegs = totalLegs > 3;
    const [showAllLegs, setShowAllLegs] = useState(false);
    const maxLegs = hasManyLegs && !showAllLegs ? 3 : undefined;
    const remainingLegs = hasManyLegs ? totalLegs - 3 : 0;
    const remainingLabel = remainingLegs === 1 ? "leg" : "legs";

    return (
        <div className="quote-table-expanded">
            {/* Desktop table view */}
            <QuoteTableExpandedTable
                legData={legData}
                maxLegs={maxLegs}
                departureTime={departureTime}
                arrivalTime={arrivalTime}
                duration={duration}
                fuelStop={fuelStop}
                passengers={passengers}
                luggage={luggage}
                departureAirport={departureAirport}
                arrivalAirport={arrivalAirport}
            />
            <QuoteTableExpandedMobile
                legData={legData}
                departureTime={departureTime}
                arrivalTime={arrivalTime}
                duration={duration}
                fuelStop={fuelStop}
                passengers={passengers}
                luggage={luggage}
                departureAirport={departureAirport}
                arrivalAirport={arrivalAirport}
            />
            {hasManyLegs && (
                <button
                    type="button"
                    className="quote-table-expanded__toggle"
                    onClick={() => setShowAllLegs((prev) => !prev)}
                >
                    {showAllLegs ? "Show fewer legs" : `Show ${remainingLegs} more ${remainingLabel}`}
                </button>
            )}
            <p className="quote-table-expanded__disclaimer">{getScheduleDisclaimer(ownerApproval)}</p>
        </div>
    );
};

export default QuoteTableExpanded;
